import { querySelectorAll } from "../utils";

const customFileHandler = () => {
    querySelectorAll('.custom-file-input').forEach(input => {
        input.addEventListener('change', (e: Event) => {
            const currentTarget = e.currentTarget as HTMLInputElement
            const target = e.target as HTMLInputElement
            const fileName = currentTarget.files[0].name;
            const nextSibling = target.nextElementSibling as HTMLElement;
            nextSibling.innerText = fileName;
        });
    });
}

export default customFileHandler;
